module.exports = __webpack_public_path__ + "static/media/munch12.960819b2.wav";